export const OperandTypes = {
  STRING: 'STRING',
  INTEGER: 'INTEGER',
  DECIMAL: 'DECIMAL',
  DATE: 'DATE',
  TIME: 'TIME',
  DATETIME: 'DATETIME',
  BOOLEAN: 'BOOLEAN',
  REF_ID: 'REF_ID',
  ENUMS: 'ENUMS'
};

export const Operators = {
  CONTAIN: 'CONTAIN',
  START_WITH: 'START_WITH',
  END_WITH: 'END_WITH',
  EQUAL: 'EQUAL',
  GREATER_EQUAL: 'GREATER_EQUAL',
  LESS_EQUAL: 'LESS_EQUAL',
  BETWEEN: 'BETWEEN',
  IN: 'IN'
};

export const StringOperators = [
  {
    id: Operators.CONTAIN,
    name: 'advanced_search.includes'
  },
  {
    id: Operators.START_WITH,
    name: 'advanced_search.start_with'
  },
  {
    id: Operators.END_WITH,
    name: 'advanced_search.end_with'
  }
];

export const NumberOperators = [
  {
    id: Operators.EQUAL,
    name: 'advanced_search.equals'
  },
  {
    id: Operators.GREATER_EQUAL,
    name: 'advanced_search.greater_equal'
  },
  {
    id: Operators.LESS_EQUAL,
    name: 'advanced_search.less_equal'
  },
  {
    id: Operators.BETWEEN,
    name: 'advanced_search.between'
  }
];

export const DateOperators = [
  {
    id: Operators.EQUAL,
    name: 'advanced_search.equals'
  },
  {
    id: Operators.GREATER_EQUAL,
    name: 'advanced_search.greater_equal'
  },
  {
    id: Operators.LESS_EQUAL,
    name: 'advanced_search.less_equal'
  },
  {
    id: Operators.BETWEEN,
    name: 'advanced_search.between'
  }
];

export const DateTimeOperators = [
  {
    id: Operators.GREATER_EQUAL,
    name: 'advanced_search.greater_equal'
  },
  {
    id: Operators.LESS_EQUAL,
    name: 'advanced_search.less_equal'
  },
  {
    id: Operators.BETWEEN,
    name: 'advanced_search.between'
  }
];

export const BooleanOperators = [
  {
    id: Operators.EQUAL,
    name: 'advanced_search.equals'
  }
];

export const RefOperators = [
  {
    id: Operators.IN,
    name: 'advanced_search.in'
  }
];

export const OperatorData = {
  [OperandTypes.STRING]: StringOperators,
  [OperandTypes.INTEGER]: NumberOperators,
  [OperandTypes.DECIMAL]: NumberOperators,
  [OperandTypes.DATE]: DateOperators,
  [OperandTypes.TIME]: DateOperators,
  [OperandTypes.DATETIME]: DateTimeOperators,
  [OperandTypes.BOOLEAN]: BooleanOperators,
  [OperandTypes.REF_ID]: RefOperators,
  [OperandTypes.ENUMS]: BooleanOperators
};
